var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-brands:chrome",
    clipPath: "url(#clip0_131_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 12.5C0 10.2246 0.608887 8.08594 1.67334 6.20605L7.03613 15.542C8.10547 17.4561 10.1514 18.75 12.5 18.75C13.1982 18.75 13.8232 18.6377 14.4922 18.4277L10.7666 24.8828C4.68262 24.0381 0 18.8135 0 12.5ZM17.8271 15.7031C18.4277 14.7656 18.75 13.6279 18.75 12.5C18.75 10.6348 17.9297 8.95996 16.6357 7.8125H24.0918C24.6777 9.25781 25 10.8447 25 12.5C25 19.4043 19.4043 24.9561 12.5 25L17.8271 15.7031ZM23.3301 6.25H12.5C9.42871 6.25 6.94824 8.40332 6.37207 11.2646L2.646 4.80811C4.93164 1.88135 8.49609 0 12.5 0C17.1289 0 21.167 2.51367 23.3301 6.25ZM8.20312 12.5C8.20312 10.127 10.127 8.20312 12.5 8.20312C14.873 8.20312 16.7969 10.127 16.7969 12.5C16.7969 14.873 14.873 16.7969 12.5 16.7969C10.127 16.7969 8.20312 14.873 8.20312 12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeWhite);
export default __webpack_public_path__ + "static/media/chrome_white.550be4fa8fe149efaa99242c2601d653.svg";
export { ForwardRef as ReactComponent };